export default __webpack_public_path__ + "static/media/auditorium_with_tables_preview.4483642c.png";